// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_case_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { PlanSubmissionKind, PlanSubmissionStatus } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { WorkflowCase, WorkflowCaseStatus } from "./workflow_case_model_pb";
import { file_bffuser_v1_workflow_case_model } from "./workflow_case_model_pb";
import type { WorkflowCaseTag, WorkflowSection, WorkflowTagPoolEntry } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_case_service.proto.
 */
export const file_bffuser_v1_workflow_case_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_workflow_case_model, file_bffuser_v1_workflow_template_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * @generated from message bffuser.v1.ListWorkflowCaseRetainedArtifactsRequest
 */
export type ListWorkflowCaseRetainedArtifactsRequest = Message<"bffuser.v1.ListWorkflowCaseRetainedArtifactsRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;
};

/**
 * Describes the message bffuser.v1.ListWorkflowCaseRetainedArtifactsRequest.
 * Use `create(ListWorkflowCaseRetainedArtifactsRequestSchema)` to create a new message.
 */
export const ListWorkflowCaseRetainedArtifactsRequestSchema: GenMessage<ListWorkflowCaseRetainedArtifactsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 0);

/**
 * @generated from message bffuser.v1.RetainedPlanSubmission
 */
export type RetainedPlanSubmission = Message<"bffuser.v1.RetainedPlanSubmission"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bfftypes.v1.PlanSubmissionKind kind = 2;
   */
  kind: PlanSubmissionKind;

  /**
   * @generated from field: int32 version = 3;
   */
  version: number;

  /**
   * @generated from field: bfftypes.v1.PlanSubmissionStatus status = 4;
   */
  status: PlanSubmissionStatus;

  /**
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 5;
   */
  submittedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.RetainedPlanSubmission.
 * Use `create(RetainedPlanSubmissionSchema)` to create a new message.
 */
export const RetainedPlanSubmissionSchema: GenMessage<RetainedPlanSubmission> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 1);

/**
 * @generated from message bffuser.v1.ListWorkflowCaseRetainedArtifactsResponse
 */
export type ListWorkflowCaseRetainedArtifactsResponse = Message<"bffuser.v1.ListWorkflowCaseRetainedArtifactsResponse"> & {
  /**
   * @generated from field: bool has_confirmed_demand_forecast = 1;
   */
  hasConfirmedDemandForecast: boolean;

  /**
   * @generated from field: repeated bffuser.v1.RetainedPlanSubmission retained_plan_submissions = 2;
   */
  retainedPlanSubmissions: RetainedPlanSubmission[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowCaseRetainedArtifactsResponse.
 * Use `create(ListWorkflowCaseRetainedArtifactsResponseSchema)` to create a new message.
 */
export const ListWorkflowCaseRetainedArtifactsResponseSchema: GenMessage<ListWorkflowCaseRetainedArtifactsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 2);

/**
 * ListWorkflowCasesRequest carries no organization_id; the BFF handler
 * resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.ListWorkflowCasesRequest
 */
export type ListWorkflowCasesRequest = Message<"bffuser.v1.ListWorkflowCasesRequest"> & {
  /**
   * @generated from field: optional bffuser.v1.WorkflowSection section = 2;
   */
  section?: WorkflowSection;

  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 3;
   */
  areaCodes: AreaCode[];

  /**
   * @generated from field: optional google.type.Date target_date_from = 4;
   */
  targetDateFrom?: Date;

  /**
   * @generated from field: optional google.type.Date target_date_to = 5;
   */
  targetDateTo?: Date;

  /**
   * statuses: when non-empty, only cases whose derived status is one of the
   * given values are returned (OR semantics). Empty means no status
   * filtering. UNSPECIFIED is not a valid element (spec AC-05,
   * workflow-delete-transition design). max_items = 5: the number of valid
   * WorkflowCaseStatus values (input-size upper bound, mirrors sibling
   * fields bg_codes=50 / target_dates=31).
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseStatus statuses = 6;
   */
  statuses: WorkflowCaseStatus[];

  /**
   * tag_labels: when non-empty, only cases carrying at least one tag whose
   * label matches one of the given labels are returned (OR semantics,
   * case-sensitive exact match).
   *
   * @generated from field: repeated string tag_labels = 7;
   */
  tagLabels: string[];

  /**
   * only_viewer_action_required: when true, only cases whose derived
   * viewer_action is REQUIRED or APPROVAL_REQUIRED are returned
   * (= 「あなたが対応すべきもののみ」 = 要対応 または 要承認). ANDed with
   * every other filter.
   *
   * The viewer itself is intentionally absent from this request: the BFF
   * handler injects the eauth member_id into the backend request. A
   * frontend-supplied viewer would be spoofable.
   *
   * @generated from field: bool only_viewer_action_required = 8;
   */
  onlyViewerActionRequired: boolean;
};

/**
 * Describes the message bffuser.v1.ListWorkflowCasesRequest.
 * Use `create(ListWorkflowCasesRequestSchema)` to create a new message.
 */
export const ListWorkflowCasesRequestSchema: GenMessage<ListWorkflowCasesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 3);

/**
 * @generated from message bffuser.v1.ListWorkflowCasesResponse
 */
export type ListWorkflowCasesResponse = Message<"bffuser.v1.ListWorkflowCasesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.WorkflowCase cases = 1;
   */
  cases: WorkflowCase[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowCasesResponse.
 * Use `create(ListWorkflowCasesResponseSchema)` to create a new message.
 */
export const ListWorkflowCasesResponseSchema: GenMessage<ListWorkflowCasesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 4);

/**
 * @generated from message bffuser.v1.GetWorkflowCaseRequest
 */
export type GetWorkflowCaseRequest = Message<"bffuser.v1.GetWorkflowCaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetWorkflowCaseRequest.
 * Use `create(GetWorkflowCaseRequestSchema)` to create a new message.
 */
export const GetWorkflowCaseRequestSchema: GenMessage<GetWorkflowCaseRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 5);

/**
 * @generated from message bffuser.v1.GetWorkflowCaseResponse
 */
export type GetWorkflowCaseResponse = Message<"bffuser.v1.GetWorkflowCaseResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.GetWorkflowCaseResponse.
 * Use `create(GetWorkflowCaseResponseSchema)` to create a new message.
 */
export const GetWorkflowCaseResponseSchema: GenMessage<GetWorkflowCaseResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 6);

/**
 * BgCodeTargets is the BG-axis creation target (mirrors
 * internalapi.v1.BgCodeTargets): one case per (bg_code, target_date). The
 * backend derives area_code from each bg_code's trailing area digit. Each
 * bg_code is a BG code or, for a template with allows_generation_target_code,
 * a 発電の計画提出者コード (spec AC-WFW-003j).
 *
 * @generated from message bffuser.v1.BgCodeTargets
 */
export type BgCodeTargets = Message<"bffuser.v1.BgCodeTargets"> & {
  /**
   * @generated from field: repeated string bg_codes = 1;
   */
  bgCodes: string[];
};

/**
 * Describes the message bffuser.v1.BgCodeTargets.
 * Use `create(BgCodeTargetsSchema)` to create a new message.
 */
export const BgCodeTargetsSchema: GenMessage<BgCodeTargets> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 7);

/**
 * AreaCodeTargets is the area-axis creation target.
 *
 * Deprecated (issue #5219, mirrors internalapi.v1.AreaCodeTargets): area is
 * no longer a creation axis. The BFF handler rejects any request that still
 * populates this oneof member with InvalidArgument.
 *
 * @generated from message bffuser.v1.AreaCodeTargets
 * @deprecated
 */
export type AreaCodeTargets = Message<"bffuser.v1.AreaCodeTargets"> & {
  /**
   * @generated from field: repeated bfftypes.v1.AreaCode area_codes = 1;
   */
  areaCodes: AreaCode[];
};

/**
 * Describes the message bffuser.v1.AreaCodeTargets.
 * Use `create(AreaCodeTargetsSchema)` to create a new message.
 * @deprecated
 */
export const AreaCodeTargetsSchema: GenMessage<AreaCodeTargets> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 8);

/**
 * NoBgTarget is the creation axis for templates that require no BG code.
 * Mirrors internalapi.v1.NoBgTarget (issue #5219); supersedes the deprecated
 * `area_targets`. Empty message: the axis carries no data beyond the shared
 * target_dates field.
 *
 * @generated from message bffuser.v1.NoBgTarget
 */
export type NoBgTarget = Message<"bffuser.v1.NoBgTarget"> & {
};

/**
 * Describes the message bffuser.v1.NoBgTarget.
 * Use `create(NoBgTargetSchema)` to create a new message.
 */
export const NoBgTargetSchema: GenMessage<NoBgTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 9);

/**
 * CreateWorkflowCasesRequest creates 1×M workflow cases in one atomic
 * transaction (one per target_date for the given creation target).
 * organization_id is intentionally absent; the BFF handler resolves it from
 * the eauth session. name / note are intentionally absent (removed in spec
 * #1515/B2).
 *
 * The creation axis is a `oneof` mirroring
 * internalapi.v1.CreateWorkflowCasesRequest: `bg_targets` when the selected
 * template requires a BG code, `no_bg_target` when it does not
 * (WorkflowTemplate.requires_bg_code drives the choice; supersedes the
 * deprecated `area_targets`, issue #5219). Field 2 previously held the flat
 * `bg_codes` and field 3 the removed `area_codes`; both numbers are reused by
 * the `bg_targets` / `area_targets` oneof members (no external clients
 * existed at that time, so reuse carried no compatibility risk).
 * `no_bg_target` is appended at field 9, matching internalapi.v1's field
 * number (field 8 was never released).
 *
 * @generated from message bffuser.v1.CreateWorkflowCasesRequest
 */
export type CreateWorkflowCasesRequest = Message<"bffuser.v1.CreateWorkflowCasesRequest"> & {
  /**
   * @generated from field: string workflow_template_id = 1;
   */
  workflowTemplateId: string;

  /**
   * @generated from oneof bffuser.v1.CreateWorkflowCasesRequest.target
   */
  target: {
    /**
     * @generated from field: bffuser.v1.BgCodeTargets bg_targets = 2;
     */
    value: BgCodeTargets;
    case: "bgTargets";
  } | {
    /**
     * @generated from field: bffuser.v1.AreaCodeTargets area_targets = 3 [deprecated = true];
     * @deprecated
     */
    value: AreaCodeTargets;
    case: "areaTargets";
  } | {
    /**
     * @generated from field: bffuser.v1.NoBgTarget no_bg_target = 9;
     */
    value: NoBgTarget;
    case: "noBgTarget";
  } | { case: undefined; value?: undefined };

  /**
   * target_dates lists the dates to create cases for.
   * max_items = 31: upper bound for a single batch (one calendar month).
   *
   * @generated from field: repeated google.type.Date target_dates = 4;
   */
  targetDates: Date[];

  /**
   * tags are applied to every case created by this batch (AC-TAG-002). When
   * empty, the created cases have no tags — the preset "定期"/"変更"
   * fallback (spec AC-TAG-002) is applied by the frontend, not the backend.
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag tags = 6;
   */
  tags: WorkflowCaseTag[];

  /**
   * removed_tag_labels mirrors internalapi.v1.CreateWorkflowCasesRequest
   * (workflow-tag-delete-ui design Decision A/C): labels to strip from
   * EVERY workflow_case + workflow_template default_tags in the
   * authenticated organization, in the same transaction as this create.
   *
   * @generated from field: repeated string removed_tag_labels = 7;
   */
  removedTagLabels: string[];
};

/**
 * Describes the message bffuser.v1.CreateWorkflowCasesRequest.
 * Use `create(CreateWorkflowCasesRequestSchema)` to create a new message.
 */
export const CreateWorkflowCasesRequestSchema: GenMessage<CreateWorkflowCasesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 10);

/**
 * @generated from message bffuser.v1.CreateWorkflowCasesResponse
 */
export type CreateWorkflowCasesResponse = Message<"bffuser.v1.CreateWorkflowCasesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.WorkflowCase workflow_cases = 1;
   */
  workflowCases: WorkflowCase[];
};

/**
 * Describes the message bffuser.v1.CreateWorkflowCasesResponse.
 * Use `create(CreateWorkflowCasesResponseSchema)` to create a new message.
 */
export const CreateWorkflowCasesResponseSchema: GenMessage<CreateWorkflowCasesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 11);

/**
 * UpdateWorkflowCaseRequest updates the mutable attributes of a workflow case.
 * Sub-step completion states are updated via ToggleSubStep, not this RPC.
 * name / note / area_codes were removed in spec #1515/B1/B2; area_code is
 * now immutable. expected_updated_at is required for optimistic locking.
 *
 * @generated from message bffuser.v1.UpdateWorkflowCaseRequest
 */
export type UpdateWorkflowCaseRequest = Message<"bffuser.v1.UpdateWorkflowCaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * tags is a full replacement of the case's tag list (AC-TAG-003: add /
   * remove is saved immediately). Unlike assignee_member_id this field has
   * no "unchanged" sentinel (repeated fields cannot express presence in
   * proto3) — the client must always resend the case's current tags on
   * every UpdateWorkflowCase call, the same convention already used for
   * target_date. Max 10 entries (AC-TAG-004).
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag tags = 8;
   */
  tags: WorkflowCaseTag[];

  /**
   * removed_tag_labels mirrors internalapi.v1.UpdateWorkflowCaseRequest
   * (workflow-tag-delete-ui design Decision A/C): labels to strip from
   * EVERY workflow_case + workflow_template default_tags in the
   * authenticated organization, in the same transaction as this update.
   *
   * @generated from field: repeated string removed_tag_labels = 9;
   */
  removedTagLabels: string[];
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowCaseRequest.
 * Use `create(UpdateWorkflowCaseRequestSchema)` to create a new message.
 */
export const UpdateWorkflowCaseRequestSchema: GenMessage<UpdateWorkflowCaseRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 12);

/**
 * @generated from message bffuser.v1.UpdateWorkflowCaseResponse
 */
export type UpdateWorkflowCaseResponse = Message<"bffuser.v1.UpdateWorkflowCaseResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdateWorkflowCaseResponse.
 * Use `create(UpdateWorkflowCaseResponseSchema)` to create a new message.
 */
export const UpdateWorkflowCaseResponseSchema: GenMessage<UpdateWorkflowCaseResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 13);

/**
 * DeleteWorkflowCaseRequest irreversibly (logically) deletes a NOT_STARTED
 * or IN_PROGRESS workflow case (spec AC-003f/g). organization_id and
 * deleted_by are intentionally absent; the BFF handler resolves
 * organization_id and injects deleted_by (eauth member_id) before calling
 * the backend — the frontend must NOT send either.
 *
 * @generated from message bffuser.v1.DeleteWorkflowCaseRequest
 */
export type DeleteWorkflowCaseRequest = Message<"bffuser.v1.DeleteWorkflowCaseRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowCaseRequest.
 * Use `create(DeleteWorkflowCaseRequestSchema)` to create a new message.
 */
export const DeleteWorkflowCaseRequestSchema: GenMessage<DeleteWorkflowCaseRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 14);

/**
 * @generated from message bffuser.v1.DeleteWorkflowCaseResponse
 */
export type DeleteWorkflowCaseResponse = Message<"bffuser.v1.DeleteWorkflowCaseResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.DeleteWorkflowCaseResponse.
 * Use `create(DeleteWorkflowCaseResponseSchema)` to create a new message.
 */
export const DeleteWorkflowCaseResponseSchema: GenMessage<DeleteWorkflowCaseResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 15);

/**
 * ToggleSubStepRequest completes a single SubStepInstance. No optimistic lock
 * is applied. is_completed=false is rejected with FailedPrecondition; undo a
 * completion with UndoSubStepCompletion (AC-WFW-005d/e/f, AC-WFW-037/038).
 *
 * @generated from message bffuser.v1.ToggleSubStepRequest
 */
export type ToggleSubStepRequest = Message<"bffuser.v1.ToggleSubStepRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * is_completed must be true.
   *
   * @generated from field: bool is_completed = 4;
   */
  isCompleted: boolean;
};

/**
 * Describes the message bffuser.v1.ToggleSubStepRequest.
 * Use `create(ToggleSubStepRequestSchema)` to create a new message.
 */
export const ToggleSubStepRequestSchema: GenMessage<ToggleSubStepRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 16);

/**
 * @generated from message bffuser.v1.ToggleSubStepResponse
 */
export type ToggleSubStepResponse = Message<"bffuser.v1.ToggleSubStepResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.ToggleSubStepResponse.
 * Use `create(ToggleSubStepResponseSchema)` to create a new message.
 */
export const ToggleSubStepResponseSchema: GenMessage<ToggleSubStepResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 17);

/**
 * UndoSubStepCompletionRequest undoes the completion of the sub-step at
 * (big_step_display_order, sub_step_display_order). organization_id is
 * intentionally absent (resolved by the BFF handler from eauth). The backend
 * rejects this request unless the target is the latest completed sub-step, no
 * later sub-step is complete or awaiting approval, and the parent workflow case
 * is not already complete (spec AC-WFW-005d/e/f, AC-WFW-008, AC-WFW-037/038).
 * It always rejects a completed plan-submission sub-step (linked page: demand
 * procurement / generation sales / demand suppression / split supply plan),
 * even when a later sub-step is complete (AC-WFW-005e (d), AC-WFW-038).
 *
 * @generated from message bffuser.v1.UndoSubStepCompletionRequest
 */
export type UndoSubStepCompletionRequest = Message<"bffuser.v1.UndoSubStepCompletionRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;
};

/**
 * Describes the message bffuser.v1.UndoSubStepCompletionRequest.
 * Use `create(UndoSubStepCompletionRequestSchema)` to create a new message.
 */
export const UndoSubStepCompletionRequestSchema: GenMessage<UndoSubStepCompletionRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 18);

/**
 * @generated from message bffuser.v1.UndoSubStepCompletionResponse
 */
export type UndoSubStepCompletionResponse = Message<"bffuser.v1.UndoSubStepCompletionResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UndoSubStepCompletionResponse.
 * Use `create(UndoSubStepCompletionResponseSchema)` to create a new message.
 */
export const UndoSubStepCompletionResponseSchema: GenMessage<UndoSubStepCompletionResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 19);

/**
 * UpdateSubStepMemoRequest mirrors internalapi.v1.UpdateSubStepMemoRequest.
 * memo_by (field 5) is reserved:
 * the BFF handler injects the eauth member_id server-side (mirrors
 * ToggleSubStepRequest.completed_by rationale) — the frontend must
 * NOT send it.
 *
 * @generated from message bffuser.v1.UpdateSubStepMemoRequest
 */
export type UpdateSubStepMemoRequest = Message<"bffuser.v1.UpdateSubStepMemoRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * memo: unset clears the memo; set stores it. A value that is empty
   * after trimming is normalized to "clear" by the backend usecase.
   * Multi-line (spec AC-WFW-005b「複数行 (改行可)」, slice #7328 / #7054):
   * line breaks are preserved as-is.
   *
   * @generated from field: optional string memo = 4;
   */
  memo?: string;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepMemoRequest.
 * Use `create(UpdateSubStepMemoRequestSchema)` to create a new message.
 */
export const UpdateSubStepMemoRequestSchema: GenMessage<UpdateSubStepMemoRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 20);

/**
 * @generated from message bffuser.v1.UpdateSubStepMemoResponse
 */
export type UpdateSubStepMemoResponse = Message<"bffuser.v1.UpdateSubStepMemoResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepMemoResponse.
 * Use `create(UpdateSubStepMemoResponseSchema)` to create a new message.
 */
export const UpdateSubStepMemoResponseSchema: GenMessage<UpdateSubStepMemoResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 21);

/**
 * ApproveSubStepStageRequest carries the identifiers needed to record an
 * approval. approver_member_id is intentionally absent; the BFF handler
 * injects it from the eauth session to prevent impersonation.
 *
 * @generated from message bffuser.v1.ApproveSubStepStageRequest
 */
export type ApproveSubStepStageRequest = Message<"bffuser.v1.ApproveSubStepStageRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: int32 stage_order = 4;
   */
  stageOrder: number;

  /**
   * note is an optional free-text memo the approver entered at approval time
   * (spec AC-WFW-007d). Empty/unset means no note.
   *
   * @generated from field: optional string note = 5;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.ApproveSubStepStageRequest.
 * Use `create(ApproveSubStepStageRequestSchema)` to create a new message.
 */
export const ApproveSubStepStageRequestSchema: GenMessage<ApproveSubStepStageRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 22);

/**
 * @generated from message bffuser.v1.ApproveSubStepStageResponse
 */
export type ApproveSubStepStageResponse = Message<"bffuser.v1.ApproveSubStepStageResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.ApproveSubStepStageResponse.
 * Use `create(ApproveSubStepStageResponseSchema)` to create a new message.
 */
export const ApproveSubStepStageResponseSchema: GenMessage<ApproveSubStepStageResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 23);

/**
 * @generated from message bffuser.v1.ApproveSubStepWithoutStagesRequest
 */
export type ApproveSubStepWithoutStagesRequest = Message<"bffuser.v1.ApproveSubStepWithoutStagesRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: optional string note = 4;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.ApproveSubStepWithoutStagesRequest.
 * Use `create(ApproveSubStepWithoutStagesRequestSchema)` to create a new message.
 */
export const ApproveSubStepWithoutStagesRequestSchema: GenMessage<ApproveSubStepWithoutStagesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 24);

/**
 * @generated from message bffuser.v1.ApproveSubStepWithoutStagesResponse
 */
export type ApproveSubStepWithoutStagesResponse = Message<"bffuser.v1.ApproveSubStepWithoutStagesResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.ApproveSubStepWithoutStagesResponse.
 * Use `create(ApproveSubStepWithoutStagesResponseSchema)` to create a new message.
 */
export const ApproveSubStepWithoutStagesResponseSchema: GenMessage<ApproveSubStepWithoutStagesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 25);

/**
 * CancelSubStepApprovalRequest cancels all pending approvals for the
 * specified sub-step.
 *
 * @generated from message bffuser.v1.CancelSubStepApprovalRequest
 */
export type CancelSubStepApprovalRequest = Message<"bffuser.v1.CancelSubStepApprovalRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * memo is the free-text reason for cancellation (spec AC-WFW-007d). Required
   * for the RPC; the backend validates that it is non-empty after trimming.
   *
   * @generated from field: string memo = 4;
   */
  memo: string;
};

/**
 * Describes the message bffuser.v1.CancelSubStepApprovalRequest.
 * Use `create(CancelSubStepApprovalRequestSchema)` to create a new message.
 */
export const CancelSubStepApprovalRequestSchema: GenMessage<CancelSubStepApprovalRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 26);

/**
 * @generated from message bffuser.v1.CancelSubStepApprovalResponse
 */
export type CancelSubStepApprovalResponse = Message<"bffuser.v1.CancelSubStepApprovalResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.CancelSubStepApprovalResponse.
 * Use `create(CancelSubStepApprovalResponseSchema)` to create a new message.
 */
export const CancelSubStepApprovalResponseSchema: GenMessage<CancelSubStepApprovalResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 27);

/**
 * UpdateSubStepApprovalNoteRequest edits or clears the note of an already-
 * recorded approval (spec AC-WFW-007a/d). approver_member_id identifies the
 * original approval record to edit; the BFF handler resolves organization_id
 * and injects note_by from the eauth session.
 *
 * @generated from message bffuser.v1.UpdateSubStepApprovalNoteRequest
 */
export type UpdateSubStepApprovalNoteRequest = Message<"bffuser.v1.UpdateSubStepApprovalNoteRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: int32 stage_order = 4;
   */
  stageOrder: number;

  /**
   * approver_member_id identifies the original approval record. P0 allows
   * any user to edit any approver's note, so this may differ from the
   * current member.
   *
   * @generated from field: string approver_member_id = 5;
   */
  approverMemberId: string;

  /**
   * note: unset clears the note; set stores it. A value empty after trimming
   * is normalized to "clear" by the backend usecase.
   *
   * @generated from field: optional string note = 6;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepApprovalNoteRequest.
 * Use `create(UpdateSubStepApprovalNoteRequestSchema)` to create a new message.
 */
export const UpdateSubStepApprovalNoteRequestSchema: GenMessage<UpdateSubStepApprovalNoteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 28);

/**
 * @generated from message bffuser.v1.UpdateSubStepApprovalNoteResponse
 */
export type UpdateSubStepApprovalNoteResponse = Message<"bffuser.v1.UpdateSubStepApprovalNoteResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepApprovalNoteResponse.
 * Use `create(UpdateSubStepApprovalNoteResponseSchema)` to create a new message.
 */
export const UpdateSubStepApprovalNoteResponseSchema: GenMessage<UpdateSubStepApprovalNoteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 29);

/**
 * @generated from message bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteRequest
 */
export type UpdateSubStepApprovalWithoutStagesNoteRequest = Message<"bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: optional string note = 4;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteRequest.
 * Use `create(UpdateSubStepApprovalWithoutStagesNoteRequestSchema)` to create a new message.
 */
export const UpdateSubStepApprovalWithoutStagesNoteRequestSchema: GenMessage<UpdateSubStepApprovalWithoutStagesNoteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 30);

/**
 * @generated from message bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteResponse
 */
export type UpdateSubStepApprovalWithoutStagesNoteResponse = Message<"bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdateSubStepApprovalWithoutStagesNoteResponse.
 * Use `create(UpdateSubStepApprovalWithoutStagesNoteResponseSchema)` to create a new message.
 */
export const UpdateSubStepApprovalWithoutStagesNoteResponseSchema: GenMessage<UpdateSubStepApprovalWithoutStagesNoteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 31);

/**
 * UpdatePreviousApprovalNoteRequest edits a preserved "前回承認時の申し送り"
 * record (Decision #3, spec L822/L830). approver_member_id + cancelled_at
 * (together with the sub-step coordinate) identify the original preserved
 * record; updated_by is injected by the BFF handler from the eauth session
 * (not carried on this bffuser-visible request — mirrors
 * UpdateSubStepApprovalNoteRequest's note_by omission).
 *
 * @generated from message bffuser.v1.UpdatePreviousApprovalNoteRequest
 */
export type UpdatePreviousApprovalNoteRequest = Message<"bffuser.v1.UpdatePreviousApprovalNoteRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: int32 stage_order = 4;
   */
  stageOrder: number;

  /**
   * approver_member_id identifies the original preserved record to edit.
   * P0 allows any user to edit any approver's note, so the frontend may
   * supply an approver other than the current member.
   *
   * @generated from field: string approver_member_id = 5;
   */
  approverMemberId: string;

  /**
   * cancelled_at disambiguates repeated approve→cancel cycles for the same
   * (stage, approver) — part of the preserved record's identity.
   *
   * @generated from field: google.protobuf.Timestamp cancelled_at = 6;
   */
  cancelledAt?: Timestamp;

  /**
   * note: unset clears the note to the empty string ("空文字化"); set stores
   * the trimmed value (which may itself be empty).
   *
   * @generated from field: optional string note = 7;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.UpdatePreviousApprovalNoteRequest.
 * Use `create(UpdatePreviousApprovalNoteRequestSchema)` to create a new message.
 */
export const UpdatePreviousApprovalNoteRequestSchema: GenMessage<UpdatePreviousApprovalNoteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 32);

/**
 * @generated from message bffuser.v1.UpdatePreviousApprovalNoteResponse
 */
export type UpdatePreviousApprovalNoteResponse = Message<"bffuser.v1.UpdatePreviousApprovalNoteResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdatePreviousApprovalNoteResponse.
 * Use `create(UpdatePreviousApprovalNoteResponseSchema)` to create a new message.
 */
export const UpdatePreviousApprovalNoteResponseSchema: GenMessage<UpdatePreviousApprovalNoteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 33);

/**
 * @generated from message bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteRequest
 */
export type UpdatePreviousApprovalWithoutStagesNoteRequest = Message<"bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: string approver_member_id = 4;
   */
  approverMemberId: string;

  /**
   * @generated from field: google.protobuf.Timestamp cancelled_at = 5;
   */
  cancelledAt?: Timestamp;

  /**
   * @generated from field: optional string note = 6;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteRequest.
 * Use `create(UpdatePreviousApprovalWithoutStagesNoteRequestSchema)` to create a new message.
 */
export const UpdatePreviousApprovalWithoutStagesNoteRequestSchema: GenMessage<UpdatePreviousApprovalWithoutStagesNoteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 34);

/**
 * @generated from message bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteResponse
 */
export type UpdatePreviousApprovalWithoutStagesNoteResponse = Message<"bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.UpdatePreviousApprovalWithoutStagesNoteResponse.
 * Use `create(UpdatePreviousApprovalWithoutStagesNoteResponseSchema)` to create a new message.
 */
export const UpdatePreviousApprovalWithoutStagesNoteResponseSchema: GenMessage<UpdatePreviousApprovalWithoutStagesNoteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 35);

/**
 * DeletePreviousApprovalNoteRequest removes a preserved "前回承認時の申し送り"
 * record entirely (Decision #3). Identity mirrors
 * UpdatePreviousApprovalNoteRequest.
 *
 * @generated from message bffuser.v1.DeletePreviousApprovalNoteRequest
 */
export type DeletePreviousApprovalNoteRequest = Message<"bffuser.v1.DeletePreviousApprovalNoteRequest"> & {
  /**
   * @generated from field: string workflow_case_id = 1;
   */
  workflowCaseId: string;

  /**
   * @generated from field: int32 big_step_display_order = 2;
   */
  bigStepDisplayOrder: number;

  /**
   * @generated from field: int32 sub_step_display_order = 3;
   */
  subStepDisplayOrder: number;

  /**
   * @generated from field: int32 stage_order = 4;
   */
  stageOrder: number;

  /**
   * @generated from field: string approver_member_id = 5;
   */
  approverMemberId: string;

  /**
   * @generated from field: google.protobuf.Timestamp cancelled_at = 6;
   */
  cancelledAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeletePreviousApprovalNoteRequest.
 * Use `create(DeletePreviousApprovalNoteRequestSchema)` to create a new message.
 */
export const DeletePreviousApprovalNoteRequestSchema: GenMessage<DeletePreviousApprovalNoteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 36);

/**
 * @generated from message bffuser.v1.DeletePreviousApprovalNoteResponse
 */
export type DeletePreviousApprovalNoteResponse = Message<"bffuser.v1.DeletePreviousApprovalNoteResponse"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowCase workflow_case = 1;
   */
  workflowCase?: WorkflowCase;
};

/**
 * Describes the message bffuser.v1.DeletePreviousApprovalNoteResponse.
 * Use `create(DeletePreviousApprovalNoteResponseSchema)` to create a new message.
 */
export const DeletePreviousApprovalNoteResponseSchema: GenMessage<DeletePreviousApprovalNoteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 37);

/**
 * @generated from message bffuser.v1.ListWorkflowTagPoolRequest
 */
export type ListWorkflowTagPoolRequest = Message<"bffuser.v1.ListWorkflowTagPoolRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWorkflowTagPoolRequest.
 * Use `create(ListWorkflowTagPoolRequestSchema)` to create a new message.
 */
export const ListWorkflowTagPoolRequestSchema: GenMessage<ListWorkflowTagPoolRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 38);

/**
 * @generated from message bffuser.v1.ListWorkflowTagPoolResponse
 */
export type ListWorkflowTagPoolResponse = Message<"bffuser.v1.ListWorkflowTagPoolResponse"> & {
  /**
   * tags: deduplicated by label, sorted by label ascending (see
   * internalapi.v1.WorkflowCaseService.ListWorkflowTagPool godoc for the
   * derivation).
   *
   * Deprecated: superseded by `entries` (workflow-tag-delete-ui design).
   * Kept for wire compatibility; no consumer reads this field.
   *
   * @generated from field: repeated bffuser.v1.WorkflowCaseTag tags = 1 [deprecated = true];
   * @deprecated
   */
  tags: WorkflowCaseTag[];

  /**
   * entries: the same tag pool as `tags`, extended with the per-label
   * reference_count / deletable signals the「作成済のタグ」box's編集モード
   * needs (AC-TAG-009, workflow-tag-delete-ui design Decision B/F).
   *
   * @generated from field: repeated bffuser.v1.WorkflowTagPoolEntry entries = 2;
   */
  entries: WorkflowTagPoolEntry[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowTagPoolResponse.
 * Use `create(ListWorkflowTagPoolResponseSchema)` to create a new message.
 */
export const ListWorkflowTagPoolResponseSchema: GenMessage<ListWorkflowTagPoolResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 39);

/**
 * @generated from message bffuser.v1.ListWorkflowGenerationTargetCandidatesRequest
 */
export type ListWorkflowGenerationTargetCandidatesRequest = Message<"bffuser.v1.ListWorkflowGenerationTargetCandidatesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListWorkflowGenerationTargetCandidatesRequest.
 * Use `create(ListWorkflowGenerationTargetCandidatesRequestSchema)` to create a new message.
 */
export const ListWorkflowGenerationTargetCandidatesRequestSchema: GenMessage<ListWorkflowGenerationTargetCandidatesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 40);

/**
 * WorkflowGenerationTargetCandidate mirrors
 * internalapi.v1.WorkflowGenerationTargetCandidate.
 *
 * @generated from message bffuser.v1.WorkflowGenerationTargetCandidate
 */
export type WorkflowGenerationTargetCandidate = Message<"bffuser.v1.WorkflowGenerationTargetCandidate"> & {
  /**
   * @generated from field: string submitter_code = 1;
   */
  submitterCode: string;

  /**
   * @generated from field: string submitter_name = 2;
   */
  submitterName: string;

  /**
   * @generated from field: string business_name = 3;
   */
  businessName: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: google.type.Date valid_from = 5;
   */
  validFrom?: Date;

  /**
   * Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 6;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.WorkflowGenerationTargetCandidate.
 * Use `create(WorkflowGenerationTargetCandidateSchema)` to create a new message.
 */
export const WorkflowGenerationTargetCandidateSchema: GenMessage<WorkflowGenerationTargetCandidate> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 41);

/**
 * @generated from message bffuser.v1.ListWorkflowGenerationTargetCandidatesResponse
 */
export type ListWorkflowGenerationTargetCandidatesResponse = Message<"bffuser.v1.ListWorkflowGenerationTargetCandidatesResponse"> & {
  /**
   * Sorted by submitter_code ascending.
   *
   * @generated from field: repeated bffuser.v1.WorkflowGenerationTargetCandidate items = 1;
   */
  items: WorkflowGenerationTargetCandidate[];
};

/**
 * Describes the message bffuser.v1.ListWorkflowGenerationTargetCandidatesResponse.
 * Use `create(ListWorkflowGenerationTargetCandidatesResponseSchema)` to create a new message.
 */
export const ListWorkflowGenerationTargetCandidatesResponseSchema: GenMessage<ListWorkflowGenerationTargetCandidatesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_case_service, 42);

/**
 * WorkflowCaseService provides Connect RPCs for managing workflow execution
 * instances (= 業務ワークフローケース).
 *
 * @generated from service bffuser.v1.WorkflowCaseService
 */
export const WorkflowCaseService: GenService<{
  /**
   * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowCaseRetainedArtifacts
   */
  listWorkflowCaseRetainedArtifacts: {
    methodKind: "unary";
    input: typeof ListWorkflowCaseRetainedArtifactsRequestSchema;
    output: typeof ListWorkflowCaseRetainedArtifactsResponseSchema;
  },
  /**
   * ListWorkflowCases returns workflow cases for the authenticated
   * organization, with optional filters.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowCases
   */
  listWorkflowCases: {
    methodKind: "unary";
    input: typeof ListWorkflowCasesRequestSchema;
    output: typeof ListWorkflowCasesResponseSchema;
  },
  /**
   * GetWorkflowCase returns the full detail of a single workflow case
   * identified by id.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.GetWorkflowCase
   */
  getWorkflowCase: {
    methodKind: "unary";
    input: typeof GetWorkflowCaseRequestSchema;
    output: typeof GetWorkflowCaseResponseSchema;
  },
  /**
   * CreateWorkflowCases creates workflow cases atomically from a single
   * workflow template, using one of two mutually exclusive creation axes
   * (issue #5219): bg_targets creates one case per (bg_code, target_date)
   * combination (N = bg_codes × target_dates) for a template that requires a
   * BG code; no_bg_target creates one case per target_date (N = target_dates)
   * for a template that does not. area is not a creation axis — it is a
   * display attribute derived from the case's own bg_code (Some for a
   * bg_targets case, UNSPECIFIED for a no_bg_target case). If any combination
   * conflicts with an existing open case (same section + bg_code +
   * target_date on the BG axis, or same section + target_date on the no-BG
   * axis), all cases are rejected and the conflicting combinations are
   * returned as WorkflowCaseConflict error details (AC-003a/b).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.CreateWorkflowCases
   */
  createWorkflowCases: {
    methodKind: "unary";
    input: typeof CreateWorkflowCasesRequestSchema;
    output: typeof CreateWorkflowCasesResponseSchema;
  },
  /**
   * UpdateWorkflowCase updates the mutable attributes of a workflow case
   * (target_date). name / note / area_codes were removed in spec #1515/B1/B2.
   * Uses optimistic locking via expected_updated_at.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateWorkflowCase
   */
  updateWorkflowCase: {
    methodKind: "unary";
    input: typeof UpdateWorkflowCaseRequestSchema;
    output: typeof UpdateWorkflowCaseResponseSchema;
  },
  /**
   * DeleteWorkflowCase irreversibly (logically) deletes a NOT_STARTED or
   * IN_PROGRESS workflow case (spec AC-003f/g). deleted_by is injected by
   * the BFF handler from the eauth session (the frontend does not send it).
   * Rejects with FailedPrecondition when the case is COMPLETE or already
   * DELETED. Uses optimistic locking via expected_updated_at
   * (workflow-delete-transition design).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.DeleteWorkflowCase
   */
  deleteWorkflowCase: {
    methodKind: "unary";
    input: typeof DeleteWorkflowCaseRequestSchema;
    output: typeof DeleteWorkflowCaseResponseSchema;
  },
  /**
   * ToggleSubStep completes a specific SubStepInstance. is_completed=false is
   * rejected with FailedPrecondition; undo a completion with UndoSubStepCompletion
   * (AC-WFW-005d/e/f, AC-WFW-037/038). No optimistic lock is applied
   * (false-alarm avoidance); the backend rejects requests on cases that are
   * already explicitly completed OR deleted (spec AC-07).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ToggleSubStep
   */
  toggleSubStep: {
    methodKind: "unary";
    input: typeof ToggleSubStepRequestSchema;
    output: typeof ToggleSubStepResponseSchema;
  },
  /**
   * UndoSubStepCompletion undoes the completion of the latest completed
   * sub-step. Rejected with FailedPrecondition when the target sub-step is not
   * complete, any later sub-step is complete or awaiting approval, or the
   * parent workflow case is already complete (spec AC-WFW-005d/e/f,
   * AC-WFW-008, AC-WFW-037/038). A completed plan-submission sub-step (linked
   * page: demand procurement / generation sales / demand suppression / split
   * supply plan) is always rejected with FailedPrecondition, even when a later
   * sub-step is complete (AC-WFW-005e (d), AC-WFW-038).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.UndoSubStepCompletion
   */
  undoSubStepCompletion: {
    methodKind: "unary";
    input: typeof UndoSubStepCompletionRequestSchema;
    output: typeof UndoSubStepCompletionResponseSchema;
  },
  /**
   * ApproveSubStepStage records the authenticated member's approval for a
   * specific approval stage of a sub-step. approver_member_id is NOT sent by
   * the frontend; the BFF handler injects it from the eauth session. Rejected
   * when the case is deleted (spec AC-07).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ApproveSubStepStage
   */
  approveSubStepStage: {
    methodKind: "unary";
    input: typeof ApproveSubStepStageRequestSchema;
    output: typeof ApproveSubStepStageResponseSchema;
  },
  /**
   * ApproveSubStepWithoutStages explicitly approves a required gate with no
   * configured approval stages. The BFF injects the authenticated member.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ApproveSubStepWithoutStages
   */
  approveSubStepWithoutStages: {
    methodKind: "unary";
    input: typeof ApproveSubStepWithoutStagesRequestSchema;
    output: typeof ApproveSubStepWithoutStagesResponseSchema;
  },
  /**
   * CancelSubStepApproval cancels all pending approvals for the specified
   * sub-step, returning it to its pre-approval state. Rejected when the case
   * is deleted (spec AC-07).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.CancelSubStepApproval
   */
  cancelSubStepApproval: {
    methodKind: "unary";
    input: typeof CancelSubStepApprovalRequestSchema;
    output: typeof CancelSubStepApprovalResponseSchema;
  },
  /**
   * UpdateSubStepMemo sets or clears the memo of a single SubStepInstance
   * (spec AC-005b, workflow-substep-memo design). memo_by is NOT sent by
   * the frontend; the BFF handler injects it from the eauth session.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepMemo
   */
  updateSubStepMemo: {
    methodKind: "unary";
    input: typeof UpdateSubStepMemoRequestSchema;
    output: typeof UpdateSubStepMemoResponseSchema;
  },
  /**
   * UpdateSubStepApprovalNote edits or clears the note of an already-
   * recorded approval (spec AC-WFW-007a/d). approver_member_id identifies
   * the original approval record; note_by is injected by the BFF handler.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepApprovalNote
   */
  updateSubStepApprovalNote: {
    methodKind: "unary";
    input: typeof UpdateSubStepApprovalNoteRequestSchema;
    output: typeof UpdateSubStepApprovalNoteResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdateSubStepApprovalWithoutStagesNote
   */
  updateSubStepApprovalWithoutStagesNote: {
    methodKind: "unary";
    input: typeof UpdateSubStepApprovalWithoutStagesNoteRequestSchema;
    output: typeof UpdateSubStepApprovalWithoutStagesNoteResponseSchema;
  },
  /**
   * UpdatePreviousApprovalNote edits a preserved "前回承認時の申し送り"
   * record (Decision #3, spec L822/L830: P0 allows any user to edit).
   * Identity is the compound (big_step_display_order, sub_step_display_order,
   * stage_order, approver_member_id, cancelled_at). updated_by is injected
   * by the BFF handler from the eauth session.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdatePreviousApprovalNote
   */
  updatePreviousApprovalNote: {
    methodKind: "unary";
    input: typeof UpdatePreviousApprovalNoteRequestSchema;
    output: typeof UpdatePreviousApprovalNoteResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.WorkflowCaseService.UpdatePreviousApprovalWithoutStagesNote
   */
  updatePreviousApprovalWithoutStagesNote: {
    methodKind: "unary";
    input: typeof UpdatePreviousApprovalWithoutStagesNoteRequestSchema;
    output: typeof UpdatePreviousApprovalWithoutStagesNoteResponseSchema;
  },
  /**
   * DeletePreviousApprovalNote removes a preserved "前回承認時の申し送り"
   * record entirely (Decision #3). Identity mirrors
   * UpdatePreviousApprovalNoteRequest. updated_by is injected by the BFF
   * handler from the eauth session.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.DeletePreviousApprovalNote
   */
  deletePreviousApprovalNote: {
    methodKind: "unary";
    input: typeof DeletePreviousApprovalNoteRequestSchema;
    output: typeof DeletePreviousApprovalNoteResponseSchema;
  },
  /**
   * ListWorkflowTagPool returns the authenticated organization's derived tag
   * pool (spec AC-TAG-005), used by the 3 tag-input screens for suggestion
   * (AC-TAG-008) and by the frontend's pre-check against the 20-tag pool cap
   * (AC-TAG-006).
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowTagPool
   */
  listWorkflowTagPool: {
    methodKind: "unary";
    input: typeof ListWorkflowTagPoolRequestSchema;
    output: typeof ListWorkflowTagPoolResponseSchema;
  },
  /**
   * ListWorkflowGenerationTargetCandidates returns the 発電の計画提出者コード the
   * creation dialog offers as BG code candidates when the selected template has
   * allows_generation_target_code (spec AC-WFW-003j). Mirrors
   * internalapi.v1.WorkflowCaseService.ListWorkflowGenerationTargetCandidates.
   *
   * @generated from rpc bffuser.v1.WorkflowCaseService.ListWorkflowGenerationTargetCandidates
   */
  listWorkflowGenerationTargetCandidates: {
    methodKind: "unary";
    input: typeof ListWorkflowGenerationTargetCandidatesRequestSchema;
    output: typeof ListWorkflowGenerationTargetCandidatesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_case_service, 0);

